import { gql } from '@apollo/client';

export default gql`
  fragment MediaItem on MediaItem {
    _id
    name
    processed
    thumbUrl
    type
    sources {
      size
      src
      type
    }
  }
`;
